import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { forwardRef } from "react";

interface WorkerImpersonateActionItemProps {
  workerName: string;
  selected: boolean;
  disabled: boolean;
  disabledReason?: string;
  onClick: () => void;
}

export const WorkerImpersonateActionItem = forwardRef<
  HTMLDivElement,
  WorkerImpersonateActionItemProps
>((props, ref) => {
  const { workerName, selected, disabled, disabledReason, onClick } = props;

  const button = (
    <ListItemButton
      ref={ref}
      disabled={disabled}
      selected={selected}
      sx={{
        paddingY: 0.75,
        paddingLeft: 6,
        paddingRight: 2,
        "&.Mui-selected": {
          backgroundColor: "action.selected",
        },
      }}
      onClick={onClick}
    >
      <ListItemIcon sx={{ minWidth: 32 }}>
        <PersonSearchIcon color={disabled ? "disabled" : "primary"} />
      </ListItemIcon>
      <ListItemText
        primary={`Impersonate ${workerName}`}
        primaryTypographyProps={{ variant: "body2" }}
      />
    </ListItemButton>
  );

  if (disabled && disabledReason) {
    return (
      <Tooltip title={disabledReason}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
});

WorkerImpersonateActionItem.displayName = "WorkerImpersonateActionItem";
